<script setup>
import { onMounted, defineEmits } from "vue"
import { ref } from "@vue/reactivity"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import { MESSAGES } from "../messages"

const defaultImage = ref(require('@/images/default.png'))

defineEmits(['force-reload'])

const showUsersPermissions = ref(true)
const appPermissions = ref([])
const arrUsers = ref([])
const abortController = ref(null)
const txtUser = ref('')
const reload = ref(false)
const isLowerThanMobile = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile = ref(KNOLIA.updateIsMobile())
const chkAllSkillCard = ref(false)
const chkAllCanValidate = ref(false)

async function GetUsers() {
    const res = await KNOLIA.CallBackEnd("get", "get-users-permissions")

    if (res.error) {
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
        return
    }

    FormatArrUsers(res.data.users)
    chkAllSkillCard.value = res.data.chkAllSkillCard
    chkAllCanValidate.value = res.data.chkAllCanValidate
}

async function GetAppPermissions() {
    const res = await KNOLIA.CallBackEnd("get", "get-operations", {
        params: {
        get: "app-permissions",
        }
    })

    if (res.error) {
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
        return
    }

    FormatAppPermissions(res.data) 
}

function FormatAppPermissions(permissions) {
    permissions.only_headship_validators = Boolean(permissions.only_headship_validators)
    appPermissions.value = permissions
}

function FormatArrUsers(users) {
    users.forEach(user => {
        user.can_search_users = Boolean(user.can_search_users)
        user.can_validate = Boolean(user.can_validate)
        user.can_manage_subordinates_activities = Boolean(user.can_manage_subordinates_activities)
        user.can_check_skill_cards = Boolean(user.can_check_skill_cards)
        user.accept_validate = Boolean(user.accept_validate)
    })

    arrUsers.value = users
}

async function SearchUsers() {
    if (txtUser.value == "") {
        GetUsers()
        return
    }

    if (abortController.value != null)
        abortController.value.abort();

    abortController.value = new AbortController();

    const res = await KNOLIA.CallBackEnd("get", "get-users-permissions", {
        params: {
            search_text: txtUser.value,
            signal: abortController.value.signal,
        },
    })

    FormatArrUsers(res.data.users)
}

async function UpdateUserPermissions(user) {
    await KNOLIA.CallBackEnd("post", "set-operations&get=user-permissions", {
        params: {
            user
        },
    })
    await GetUsers()
}

async function ChangeAppPermission() {
    await KNOLIA.CallBackEnd("post", "set-operations&get=app-permissions", {
        params: {
            app_permissions: appPermissions.value
        },
    })
}

function ShowUsersPermissions() {
  return showUsersPermissions.value
}

function getTeamsTooltip(user) {
    let tooltip = ''
    if(user.assigned_teams?.length > 0) {
        user.assigned_teams.forEach(elem => tooltip += elem.designation + ', ')
    } else {
        return '[sem equipa]'
    }

    return `Equipa(s): \r\n\r\n${tooltip.replaceAll(",", "\n").trim()}`
}

async function SetAllChk(isSkillCard, value) {
    await KNOLIA.CallBackEnd("post", "set-operations&get=chk-all-users", {
        params: {
            chk_skill_card: isSkillCard,
            chk_value: value
        },
    })
    await GetUsers()
}

onMounted(async () => {
    await GetUsers()
    await GetAppPermissions()

    window.addEventListener('resize', () => {
        isMobile.value = KNOLIA.updateIsMobile()
        isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
    })
})

</script>

<template>
    <div>
        <div class="tab-container">
            <div class="tab" :class="{'tab-active': ShowUsersPermissions()}" @click="showUsersPermissions = !showUsersPermissions">UTILIZADORES</div>
            <div class="tab" :class="{'tab-active': !ShowUsersPermissions()}" @click="showUsersPermissions = !showUsersPermissions">APLICAÇÃO</div>
        </div>

        <div class="page-container">
            <div class="users-permissions" v-show="showUsersPermissions">
                <div v-if="!isMobile && !isLowerThanMobile">
                    <div class="div-search-users">
                        <div class="col-7">
                            <input type="text" class="input-user" placeholder="Pesquisar colaborador..." v-model="txtUser" @keyup="SearchUsers()">
                        </div>

                        <div class="col-2 chk-all">
                            <input class="chk cursor-pointer" type="checkbox" v-model="chkAllCanValidate" @change="SetAllChk(false, chkAllCanValidate)">
                            <label for="">Marcar todos "Pode Validar"</label>
                        </div>

                        <div class="col-2 chk-all">
                            <input class="chk cursor-pointer" type="checkbox" v-model="chkAllSkillCard" @change="SetAllChk(true, chkAllSkillCard)">
                            <label for="">Marcar todos "Consultar Cédulas"</label>
                        </div>

                    </div>

                    <div class="row header gap-2">
                        <div class="col-auto div-photo p-0"></div>
                        <div class="col-2 p-0">Nome</div>
                        <div class="col-2 line-clamp line-clamp-1 p-0 div-row-height">Função</div>
                        <div class="col-1 line-clamp line-clamp-1 p-0 div-row-height">Categoria</div>
                        <div class="col-1 line-clamp line-clamp-1 p-0 text-center">
                            <div class="line-clamp line-clamp-1">Procurar</div>
                            <div class="line-clamp line-clamp-1">Pessoas</div>
                        </div>
                        <div class="col-2 p-0 div-search-people">
                            Validar
                            <div class="d-flex">
                                <div class="col-6 line-clamp line-clamp-1 p-0">Pode</div>
                                <div class="col-6 line-clamp line-clamp-1 p-0">Aceita</div>
                            </div>
                        </div>
                        <div class="col-1 p-0 text-center">
                            <div class="line-clamp line-clamp-1">Atribuir</div>
                            <div class="line-clamp line-clamp-1">Atividades</div>
                        </div>
                        <div class="col-1 p-0 text-center">
                            <div class="line-clamp line-clamp-1">Consultar</div>
                            <div class="line-clamp line-clamp-1">Cédulas</div>
                        </div>
                    </div>

                    <div class="users-list" :key="reload">
                        <div class="row align-items-center gap-2" v-for="(user, index) in arrUsers" :key="user.id" :class="{ 'bg-alt-line': index % 2 == 0 }">
                            <div class="p-0 col-auto">
                                <img class="user-photo" :src="user.src ?? defaultImage" @error="$event.target.src = defaultImage">
                            </div>

                            <span class="col-2 line-clamp line-clamp-1 fw-bold p-0 cursor-default" @mouseenter="Gems.Tooltip($event.target, getTeamsTooltip(user), 'tooltip tooltip-left')">
                                {{ user.name }}
                            </span>
                            <span class="col-2 line-clamp line-clamp-1 p-0">{{ user.job }}</span>
                            <span class="col-1 line-clamp line-clamp-1 p-0">{{ user.category }}</span>

                            <span class="col-1 text-center p-0" @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.CAN_SEARCH_USERS_PERMISSION, 'tooltip')">
                                <input class="chk cursor-pointer" v-if="!user.admin" type="checkbox" v-model="user.can_search_users" @change="UpdateUserPermissions(user)">
                                <input class="chk cursor-pointer disabled" v-else type="checkbox" checked>
                            </span>

                            <span class="col-2 p-0 div-search-people">
                                <div class="d-flex">
                                    <div class="col-6" @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.CAN_VALIDATE_PERMISSION, 'tooltip tooltip-left')">
                                        <input class="chk cursor-pointer" :class="{'disabled': appPermissions.only_headship_validators && !user.is_headship}" v-if="!user.admin"
                                        type="checkbox" v-model="user.can_validate" @change="UpdateUserPermissions(user)">

                                        <input class="chk cursor-pointer disabled" v-else type="checkbox" checked>
                                    </div>

                                    <div class="col-6" @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.ACCEPT_VALIDATE_PERMISSION, 'tooltip tooltip-left')">
                                        <i class="bi bi-check2 i-accept-validate" v-if="user.accept_validate || user.admin"></i>
                                    </div>
                                </div>
                            </span>

                            <span class="col-1 justify-content-center d-flex p-0" @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.CAN_MANAGE_SUBORDINATES_ACTIVITIES_PERMISSION, 'tooltip')">
                                <input class="chk cursor-pointer" :class="{'disabled': !user.is_headship}" v-if="!user.admin"
                                type="checkbox" v-model="user.can_manage_subordinates_activities" @change="UpdateUserPermissions(user)">

                                <input class="chk cursor-pointer disabled" v-else type="checkbox" checked>
                            </span>

                            <span class="col-1 justify-content-center d-flex p-0"
                             @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.SKILL_CARD_PERMISSION, 'tooltip')">
                                <input class="chk cursor-pointer" v-if="!user.admin" type="checkbox" v-model="user.can_check_skill_cards" @change="UpdateUserPermissions(user)">
                                <input class="chk cursor-pointer disabled" v-else type="checkbox" checked>
                            </span>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="div-search-users">
                        <input type="text" class="input-user" placeholder="Pesquisar colaborador..." v-model="txtUser" @keyup="SearchUsers()">
                    </div>

                    <div class="row header gap-3">
                        <div class="p-0 col-2"></div>
                        <div class="p-0 col-4"></div>
                        <div class="p-0 col-4 line-clamp line-clamp-2">Função</div>
                    </div>

                    <div class="users-list" :key="reload">
                        <div v-for="(user, index) in arrUsers" :key="user.id" :class="{ 'bg-alt-line': index % 2 == 0 }">
                            <div class="row align-items-center gap-3">
                                <div class="p-0 col-2">
                                    <img class="user-photo" :src="user.src ?? defaultImage" @error="$event.target.src = defaultImage">
                                </div>

                                <span class="p-0 col-4 line-clamp line-clamp-1 fw-bold">{{ user.name }}</span>
                                <span class="p-0 col-4 line-clamp line-clamp-1">{{ user.job }}</span>
                                <i class="p-0 col-auto bi bi-chevron-down align-content-center" :class="{'bi-chevron-up': user.showDetail}" @click="user.showDetail = !user.showDetail"></i>

                            </div>

                            <div class="row" v-show="user.showDetail">
                                <div class="col-3 line-clamp line-clamp-2 p-0 div-search-people">Procurar Pessoas</div>
                                <div class="col-3 p-0 div-search-people">
                                    Validar
                                    <div class="d-flex">
                                        <div class="col-6 line-clamp line-clamp-1 p-0">Pode</div>
                                        <div class="col-6 line-clamp line-clamp-1 p-0">Aceita</div>
                                    </div>
                                </div>
                                <div class="col-3 line-clamp line-clamp-2 p-0 text-center">Atribuir Atividades</div>
                                <div class="col-3 line-clamp line-clamp-2 p-0 text-center">Consultar Cédulas</div>
                            </div>
                            
                            <div class="row" v-show="user.showDetail">
                                <span class="p-0 col-3 text-center">
                                    <input class="mobile-chk cursor-pointer" type="checkbox" v-model="user.can_search_users" @change="UpdateUserPermissions(user)">
                                </span>
        
                                <span class="p-0 col-3 div-search-people">
                                    <div class="d-flex">
                                        <div class="col-6"> 
                                            <input class="mobile-chk cursor-pointer" :class="{'disabled': appPermissions.only_headship_validators}" 
                                                type="checkbox" v-model="user.can_validate" @change="UpdateUserPermissions(user)">
                                        </div>
        
                                        <div class="col-6">
                                            <i class="bi bi-check2 i-accept-validate" v-if="user.accept_validate"></i>
                                        </div>
                                    </div>
                                </span>

                                <span class="p-0 col-3 justify-content-center d-flex">
                                    <input class="mobile-chk cursor-pointer" type="checkbox" v-model="user.can_manage_subordinates_activities" @change="UpdateUserPermissions(user)">
                                </span>
        
                                <span class="p-0 col-3 justify-content-center d-flex">
                                    <input class="mobile-chk cursor-pointer" type="checkbox" v-model="user.can_check_skill_cards" @change="UpdateUserPermissions(user)">
                                </span>
                            </div>


                        </div>
                    </div>
                </div>

            </div>

            <div class="app-permissions" v-show="!showUsersPermissions">
                <div class="div-permission-row">
                    <input type="checkbox" class="chk cursor-pointer" v-model="appPermissions.only_headship_validators" @change="ChangeAppPermission()">
                    <span>Limitar validadores à(s) chefia(s) direta(s).</span>
                </div>
            </div>
            
        </div>
    </div>
</template>

<style scoped>

.tab-container {
  display: flex;
  justify-content: space-between;
}

.div-search-users {
    display: flex;
    margin-bottom: 1%;
    gap: 50px;
    align-items: center;
}

.chk-all {
    display: flex;
    gap: 10px;
}

.div-inactives-checkbox {
    display: flex;
    align-self: center;
    margin-left: 10px;
}

.mobile-chk {
    transform: scale(1.1);
}

.chk {
    vertical-align: middle;
    transform: scale(1.5);
}

.i-accept-validate {
    transform: scale(2);
    display: inline-block;
    vertical-align: middle;
}

.input-user {
    width: 100%;
    font-style: italic;
}

.header {
    font-weight: 600;
    margin-bottom: 0px !important;
    height: fit-content !important;
    padding: 3px 6px;
}

.user-name {
    font-weight: bold;
    margin-left: 5px;
}

.div-search-people {
    text-align: center;
}


.user-photo {
    height: 30px;
    width: 31px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    box-shadow: 0 0 10px 1px rgb(0, 0, 0, 0.1);
    margin: 0 auto;
    object-fit: cover;
}

.row {
    height: 40px;
    margin: 0px;
    border-radius: 5px;
    padding: 5px;
    /* justify-content: space-evenly; */
}

.div-permission-row {
    display: flex;
    gap: 10px;
}

.div-photo {
    width: 31px;
}

.div-row-height {
    height: 1lh;
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>
